import consumer from "./consumer"

consumer.subscriptions.create("TranslationProgressChannel", {
  connected() {
    // console.log("Connected to TranslationProgressChannel");
  },

  disconnected() {
    // console.log("Disconnected from TranslationProgressChannel");
  },

  received(data) {
    if (data.translation_id) {
      // Find the progress bar for this specific translation
      const progressContainer = document.querySelector(`[data-translation-id="${data.translation_id}"]`);
      const progressBar = progressContainer?.querySelector('.progress-bar');
      
      if (progressContainer && progressBar) {
        if (data.error) {
          progressBar.classList.remove('bg-success');
          progressBar.classList.add('bg-danger');
          progressBar.style.width = '100%';
          progressBar.textContent = data.error;
          return;
        }

        progressBar.style.width = `${data.progress}%`;
        progressBar.setAttribute('aria-valuenow', data.progress);
        progressBar.textContent = `${data.progress}%`;
        
        if (data.complete) {
          // Remove the progress bar when complete
          progressContainer.remove();
          // Refresh the page to show updated translation
          window.location.reload();
        }
      }
    }
  }
});
